import LinkedText from "../../LinkedText";
import {getRandomColor} from "../../../utils/GetRandomColor";
import invitation from "../../../assets/img/blog/googleFoobarChallange/invitation.png"
import IconText from "../../IconText";
import {faEnvelopeOpenText} from "@fortawesome/free-solid-svg-icons";

export default function TheInvitation() {
    const imageStyle = {
        border: `5px solid ${getRandomColor()}`,
    };
    
    return (
        <div className={"blog-body"}>
            <h1><IconText text={"The Invitation"} icon={faEnvelopeOpenText}/></h1>
            <p>
                One day, while I was working on my projects, a message appeared at the top of my Google search
                results.
                I don't exactly remember what I was searching for, but I guess it was about multi-threading.
            </p>
            <img style={imageStyle} className={"blog-img"} src={invitation}
                 alt={"Google Foobar Challange Invitation"}/>
            <p>
                After clicking the message, I was redirected to a <LinkedText
                href={"https://foobar.withgoogle.com/"} text={"website"}></LinkedText>, and the challenge
                has started. The
                challenge consists of 5 levels and 9 questions in total.
            </p>

            <div className={"blog-quote"}>
                <ul>
                    <li>Level 1
                        <ul>
                            <li>1. Re-ID</li>
                        </ul>
                    </li>

                    <li>Level 2
                        <ul>
                            <li>2.1. Hey, I Already Did That!</li>
                            <li>2.2. Elevator Maintenance</li>
                        </ul>
                    </li>

                    <li>Level 3
                        <ul>
                            <li>3.1. Prepare the Bunnies' Escape</li>
                            <li>3.2. Doomsday Fuel</li>
                            <li>3.3. Don't Get Volunteered!</li>
                        </ul>
                    </li>

                    <li>Level 4
                        <ul>
                            <li>4.1. Free the Bunny Workers</li>
                            <li>4.2. Bringing a Gun to a Trainer Fight</li>
                        </ul>
                    </li>

                    <li>Level 5
                        <ul>
                            <li>5. Expanding Nebula</li>
                        </ul>
                    </li>
                </ul>
            </div>

            <p>
                For context, we are in a space station where Commander Lambda is on charge, and we are trying to
                help the bunnies used as workers.
            </p>
        </div>
    );
}
    